var EXELARE_SVC_URL = "//jobs.exelare.com/jobsWidget/"; //"http://localhost:31973/";
var folderToLoad = "BuiltScripts";
//var exelare_jobs = window;

//CURRENTLY IN DEBUG MODE, to put back to PRODUCTION:
//1. change url
//2. change folderToLoad="BuiltScripts"
//3. change index.html load script paths to "BuiltScripts"
//4. comment exelare_jobs=window;


function loadCss(url) {
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    document.getElementsByTagName("head")[0].appendChild(link);
}

function loadCanonical(url) {
    var link = document.createElement("link");
    link.rel = "canonical";
    link.href = url;
    document.getElementsByTagName("head")[0].appendChild(link);
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

Date.prototype.yyyymmdd = function () {
    var yyyy = this.getFullYear().toString();
    var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
    var dd = this.getDate().toString();
    return yyyy + '-'+ (mm[1] ? mm : "0" + mm[0]) + '-'+(dd[1] ? dd : "0" + dd[0]); // padding
};

Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
}


//IE console fix
if (!window.console) console = { log: function (obj) { }};

exelare_jobs.require.config({
    baseUrl: EXELARE_SVC_URL +folderToLoad,
    paths: {
        "noconflict": "lib/noconflict",
        "jquery": 'lib/jquery-2.1.0',
        "bootstrap": 'lib/bootstrap.min',
        "helpers": "utils/helpers",
        'datasource': 'utils/AjaxDataSource',
        'underscore': 'lib/underscore-min',
        'knockout': 'lib/knockout-3.1.0',
        "settingsMgr": "utils/SettingsMgr",
        "jobDetailModel": "models/JobDetailModel",
        "jobListModel": "models/JobListModel",
        "appFormModel": "models/AppFormModel",
        "jquery-bbq": "lib/jquery.ba-bbq.min",
        "jquery-browser-fix": "lib/jquery.browser.fix",
        "bootstrap-datepicker": "lib/bootstrap-datepicker",
        "ko-money": "lib/ko.money",
        "bootstrap-validator": "lib/bootstrapValidator.min",
        "main_jobs": "main_jobs",
        "main_button": "main_button",
        "main_candidate": "main_candidate"
    },
    shim: {
        "bootstrap": {
            deps: ['jquery']
        },
        "bootstrap-datepicker": {
            deps: ['bootstrap']
        },
        "bootstrap-validator": {
            deps: ['bootstrap']
        },
        "jquery-bbq": {
            deps: ["jquery",
                   "jquery-browser-fix"]
        },
        "jquery-browser-fix": {
            deps: ["jquery"]
        }
    }
});

exelare_jobs.define('main',["jquery", "knockout", "ko-money", "settingsMgr", "bootstrap", "bootstrap-datepicker", "bootstrap-validator", "jquery-bbq"],
    function ($, ko, ko_money, setMgr) {
       var self = this;
       $.noConflict(true);


       window.urlExists=function(url, callback) {
           //var http = new XMLHttpRequest();
           //http.open('HEAD', url, false);
           //http.send();
           //return http.status != 404;

           $.ajax({
               type: 'HEAD',
               async: true,
               url: url,
           }).done(function() {callback(true);}).fail(function() {callback(false);});
       }

       ko_money(ko);

       $(document).ready(function () {
               self.SettingsMgr = setMgr;
                //initialization:
               self.container = $('#exelare_jobs_container');
               

               self.args = {};

               if (window.location.hash) {
                   self.args = $.deparam.fragment();
                   //console.log(args);
               }

               if (window.location.search) {
                   var sArgs = window.location.search.substring(1).split("&");
                   
                   for(var i=0;i<sArgs.length;i++) {
                       var sParts = sArgs[i].split("=");
                       if (sParts.length==2) self.args[sParts[0]] = decodeURIComponent(sParts[1].replace(/\+/g, " "));
                   }
                   console.log(self.args);
               }

               if (!self.args.companyId) self.args.companyId = container.attr('data-companyId');
               if (!self.args.userId) self.args.userId = container.attr('data-userId');

               self.SettingsMgr(self.args, function (setts) {
                   //console.log(setts);

                   loadCss(setts.mapUrl('Content/bootstrap.css'));
                   loadCss(setts.mapUrl('Content/bootstrapValidator.min.css'));
                   loadCss(setts.mapUrl('Content/styles.css'));
                   loadCss(setts.mapUrl('Content/plugins/datepicker3.css'));
                   loadCanonical(window.location.toString());

                   self.ExelareSettings = setts;

                   require(["jobDetailModel", "jobListModel", "appFormModel", "helpers"], function (jobDetailModel, jobListModel, appFormModel, helpers) {

                       //creating classes
                       self.JobDetailModel = jobDetailModel;
                       self.JobListModel = jobListModel;
                       self.AppFormModel = appFormModel;
                       self.helpers = helpers;

                       var route = $("#exelare_jobs_script").attr("data-route");

                       if (!route) { route = "jobs" };

                       switch (route) {
                           case "jobs":
	                           require(["main_jobs"], function(main) {
		                           main($, ko, self);
	                           });
                               break;
                           case "button":
	                           require(["main_button"], function(main) {
		                           main($, ko, self);
	                           });
                               break;
                           case "candidate":
	                           require(["main_candidate"], function(main) {
		                           main($, ko, self);
	                           });
                               break;
                       }
                  });
               });
        });
});
